// Plain-English messages for the onboarding reminder actions (CWA-189). The
// codes come from contracts/api.md in account-management's
// specs/029-onboarding-reminders and arrive as `error_code` on the service's
// ErrorResponse. `message` is engineering text and is never shown.

const MESSAGES: Record<string, string> = {
  INVALID_SNOOZE: "Pick a snooze date between tomorrow and 90 days from today.",
  REMINDERS_DISABLED:
    "Automatic reminders are off on this environment, so nothing can be sent from here.",
  NO_STALLED_STEP: "Nothing is waiting on this prospect, so there is no reminder to send.",
  REMINDER_LADDER_COMPLETE:
    "Every reminder for this step has already been sent. Log a call instead.",
  REMINDER_IN_PROGRESS:
    "A reminder for this prospect is being sent right now. Wait a moment, then reload the page.",
  INVALID_FOLLOW_UP_CALL: "Enter a note about the call, at most 2,000 characters.",
  MORE_INFO_NOT_REQUESTED:
    "There is no open request for more information. Reload the page to see the current state.",
  NO_CUSTOMER_REMINDER:
    "The move is support's, so there is no customer reminder for this step.",
};

export const reminderErrorMessage = (err: any): string => {
  const code = err?.response?.data?.error_code;
  if (typeof code === "string" && MESSAGES[code]) return MESSAGES[code];
  if (err?.response?.status === 404) {
    return "This prospect could not be found. Reload the page and try again.";
  }
  return "The reminders could not be updated. Please try again.";
};
